import { render } from "./AdvTransfer.vue?vue&type=template&id=dfd8fc62&scoped=true"
import script from "./AdvTransfer.vue?vue&type=script&lang=js"
export * from "./AdvTransfer.vue?vue&type=script&lang=js"

import "./AdvTransfer.vue?vue&type=style&index=0&id=dfd8fc62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd8fc62"]])

export default __exports__